export enum MaintenanceWorkOrderStatusEnum {
  Unclaimed,
  Claimed,
  InProgress,
  Completed,
}
